<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <loading :active.sync="isPageLoading" is-full-page></loading>
        <div v-if="!isPageLoading">
          <div class="page-title">
            <h1>Zones</h1>
          </div>
          <div class="page-content">
            <form>
              <div class="form-group row">
                <label for="searchKeyword" class="col-sm-2 col-form-label">Search by Keyword</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="searchKeyword" />
                </div>
                <div class="col-sm-2">
                  <button v-if="$permissions().hasEditZonePermission" type="button" class="btn btn-primary" @click="newZone">
                    <i class="fas fa-plus-circle"></i> Add New
                  </button>
                </div>
              </div>
            </form>
            <ul class="list-group list-group-flush border-bottom">
              <li class="list-group-item d-flex px-2" v-for="zone in searchLocalDataset(getZones)" :key="zone.id">
                <div class="mr-auto">
                  <p class="m-0">{{ zone.name }}</p>
                  <p class="m-0 small-grey">{{ zone.abbreviation }}</p>
                </div>
                <a role="button" v-if="$permissions().hasEditZonePermission" href="#"
                    class="d-flex justify-content-between align-items-center flex-column" title="Edit" @click.prevent="editZone(zone.id)">
                  <img class="mb-1" src="@/assets/document.svg" alt />
                  <span class="small-grey">Edit</span>
                </a>
                <a role="button" v-if="$permissions().hasDeleteZonePermission" href="#"
                    class="d-flex justify-content-between align-items-center flex-column ml-3 zone-delete-trigger" title="Delete" @click.prevent="deleteZone(zone.id)">
                  <img class="mb-1" src="@/assets/red_x.svg" alt />
                  <span class="small-grey">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-zone" size="lg" hide-header hide-footer :no-close-on-backdrop="true">
      <zone></zone>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MessageBox from "@/utils/messagebox";
import Toast from "@/utils/toast";

export default {
  name: "configuration-zones",
  components: {
    'app-navbar': () => import('@/components/app-navbar.vue'),
    'zone': () => import('@/views/configuration/components/zone.vue')
  },
  data: function() {
    return {
      isPageLoading: true,
      searchKeyword: null
    };
  },
  computed: {
    ...mapGetters(["getZones"])
  },
  methods: {
    newZone() {
      this.resetZone().then(() => {
        this.$bvModal.show("bv-modal-zone");
      });
    },
    editZone(id) {
      this.fetchZone(id).then(() => {
        this.$bvModal.show("bv-modal-zone");
      });
    },
    async deleteZone(id) {
      let confirm = await MessageBox.confirm(this, "Remove Zone", "Are you sure you want to remove zone?");

      if (confirm) {
        this.removeZone(id).then(() => {
          Toast.success(this, "Successfully removed zone!");
        });
      }
    },
    searchLocalDataset(values) {
      if (!this.searchKeyword || this.searchKeyword === "") return values;

      return values.filter(
        i =>
          i.name.includes(this.searchKeyword) ||
          i.abbreviation.includes(this.searchKeyword)
      );
    },
    ...mapActions(["fetchZone", "fetchZones", "removeZone", "resetZone"])
  },
  mounted: function() {
    this.fetchZones().then(() => {
      this.isPageLoading = false;
    });
  }
};
</script>
